import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appLostFocus]',
})
export class LostFocusDirective {
  @Input('appLostFocus') lostFocusCallback?: () => void;

  constructor(private el: ElementRef) {}

  @HostListener('focusout', ['$event'])
  handleFocusOut(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;

    // Check if the new focused element is outside the current element
    if (relatedTarget && !this.el.nativeElement.contains(relatedTarget)) {
      if (this.lostFocusCallback) {
        this.lostFocusCallback();
      }
    }
  }
}
